class Accordeon {

  constructor (el) {
    this.el = el
    this.items = this.el.querySelectorAll('.js-accordeon-item')
    this.buttons = this.el.querySelectorAll('.js-accordeon-button')
    this.content = this.el.querySelectorAll('.js-accordeon-content')
    this.initDefault()
  }

  initDefault () {
    this.init()
    this.initEvents()
  }

  initEvents () {
    this.buttons.forEach( el => { el.addEventListener('click', e => this.toggle(e)) })
  }

  init () {
    this.items.forEach( el => { 
      const content = el.querySelector('.js-accordeon-content')
      el.classList.contains('active') ? content.style.display = 'block' : content.style.display = 'none'
    })
  }

  toggle (e) {
    e.preventDefault()
    const target = e.currentTarget
    const parent = target.closest('.js-accordeon-item')
    if ( parent.classList.contains('active') ) {
      this.closeTab(parent)
    } else {
      this.closeAllTabs()
      this.openTab(parent)
    }
  }

  closeTab (el) {
    el.classList.remove('active')
    const content = el.querySelector('.js-accordeon-content')
    $(content).slideUp(300).promise().done(() => {
      content.style.display = 'none'
    })
  }

  openTab (el) {
    el.classList.add('active')
    const content = el.querySelector('.js-accordeon-content')
    $(content).slideDown(300).promise().done(() => {
      content.style.display = 'block'
    })
  }

  closeAllTabs () {
    this.items.forEach( el => { el.classList.remove('active') })
    this.content.forEach( el => { 
      $(el).slideUp(300).promise().done(() => {
        el.style.display = 'none'
      })
    })
  }

  openNewTab (el) {

  }

}

document.addEventListener("DOMContentLoaded", () => {
  const el = document.querySelectorAll(".js-accordeon");
  if ( el ) {
    el.forEach( el => {
      new Accordeon(el);
    })
  }
});